
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Environments from './components/Environments';
import ServiceAreas from './components/Portfolio';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import MobileFloatingNav from './components/MobileFloatingNav';

export default function Home() {
  return (
    <div>
      <Navbar />
      <Hero />
      <Services />
      <Environments />
      <ServiceAreas />
      <Contact />
      <About />
      <Footer />
      <MobileFloatingNav />
    </div>
  );
}
